import { render, staticRenderFns } from "./PaymentTutorial.vue?vue&type=template&id=e56dc6a0&scoped=true"
import script from "./PaymentTutorial.vue?vue&type=script&lang=js"
export * from "./PaymentTutorial.vue?vue&type=script&lang=js"
import style0 from "./PaymentTutorial.vue?vue&type=style&index=0&id=e56dc6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56dc6a0",
  null
  
)

export default component.exports